import { gql } from "@apollo/client";

export const PARCEL_QUERY = gql`
query ParcelTask {
parcels {
  id
  parcel_name
  rooms {
    id
    room_id
    version
   }
  }
}
`


